import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const CommentSchema = withDefaults({
  type: 'comment',
  objectExtensions: ['comment'],
  fields: [
    {
      kind: 'attribute',
      name: 'comment',
    },
    {
      kind: 'attribute',
      name: 'commentor',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'attribute',
      name: 'tags',
    },
    {
      kind: 'belongsTo',
      name: 'commentable',
      type: 'commentable',
      options: {
        async: false,
        polymorphic: true,
        inverse: 'comments',
      },
    },
    {
      kind: 'belongsTo',
      name: 'person',
      type: 'person',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default CommentSchema;
